import React from 'react'
import { Content } from 'components'
import { CustomLinks } from 'components'
import styled from 'styled-components'
import { device } from 'utils/device'
import { BsQuestionCircle, BsChatSquareDots, BsFileText } from 'react-icons/bs'

const HelpInfo = () => {
  const sections = [
    {
      key: 'HELP_INFO.ANSWERS',
      icon: <BsQuestionCircle />,
      title: 'Questions',
    },
    {
      key: 'HELP_INFO.DOCUMENTATION',
      icon: <BsFileText />,
      title: 'Documentation',
    },
    {
      key: 'HELP_INFO.SUPPORT',
      icon: <BsChatSquareDots />,
      title: 'Support',
    },
    {
      key: 'HELP_INFO.FEEDBACK',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          fill="currentColor"
          className="bi bi-megaphone"
          viewBox="0 0 16 16"
        >
          <path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-.214c-2.162-1.241-4.49-1.843-6.912-2.083l.405 2.712A1 1 0 0 1 5.51 15.1h-.548a1 1 0 0 1-.916-.599l-1.85-3.49a68.14 68.14 0 0 0-.202-.003A2.014 2.014 0 0 1 0 9V7a2.02 2.02 0 0 1 1.992-2.013 74.663 74.663 0 0 0 2.483-.075c3.043-.154 6.148-.849 8.525-2.199V2.5zm1 0v11a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-1 0zm-1 1.35c-2.344 1.205-5.209 1.842-8 2.033v4.233c.18.01.359.022.537.036 2.568.189 5.093.744 7.463 1.993V3.85zm-9 6.215v-4.13a95.09 95.09 0 0 1-1.992.052A1.02 1.02 0 0 0 1 7v2c0 .55.448 1.002 1.006 1.009A60.49 60.49 0 0 1 4 10.065zm-.657.975 1.609 3.037.01.024h.548l-.002-.014-.443-2.966a68.019 68.019 0 0 0-1.722-.082z" />
        </svg>
      ),
      title: 'Feedback',
    },
  ]

  return (
    <Content>
      {sections.map(({ key, icon, title }) => (
        <Section key={key}>
          <h5>
            {icon} {title}
          </h5>
          <CustomLinks location={key}/>
        </Section>
      ))}
    </Content>
  )
}

const Section = styled.section`
  margin-left: 5rem;

  > h5 {
    color: ${({ theme }) => theme.palette.primary[0]};
    margin: 1.5rem 0;

    > svg {
      font-size: 2rem;
      margin-right: 0.7rem;
    }
  }

  > p {
    font-size: 0.9rem;
    font-weight: 100;
    margin-bottom: 0.5rem;
    margin-left: 3rem;

    a {
      color: ${({ theme }) => theme.link.color};
    }

    &:last-child {
      margin-bottom: 3rem;
    }
  }

  @media ${device.mobileL} {
    margin-left: 0.5rem;
  }
`

export default HelpInfo
